import { useMemo } from 'react';

const MIN_LENGTH = 8;
const MAX_LENGTH = 20;

type ValidationRule = {
  label: string;
  test: (candidate: string) => boolean;
  errorMessage: (candidate: string) => string;
};

const rules: ValidationRule[] = [
  {
    label: `Min. ${MIN_LENGTH} i maks. ${MAX_LENGTH} znaków`,
    test: (candidate) => candidate.length >= MIN_LENGTH && candidate.length <= MAX_LENGTH,
    errorMessage: (candidate) => candidate.length < MIN_LENGTH
      ? `Hasło jest za krótkie – minimum ${MIN_LENGTH} znaków (wpisano ${candidate.length})`
      : `Hasło jest za długie – maksimum ${MAX_LENGTH} znaków (wpisano ${candidate.length})`,
  },
  {
    label: 'Min. 1 wielka i mała litera',
    test: (candidate) => /\p{Ll}/u.test(candidate) && /\p{Lu}/u.test(candidate),
    errorMessage: (candidate) => /\p{Lu}/u.test(candidate)
      ? 'Hasło musi zawierać małą literę'
      : 'Hasło musi zawierać wielką literę',
  },
  {
    label: 'Min. 1 cyfra',
    test: (candidate) => /[0-9]/.test(candidate),
    errorMessage: () => 'Hasło musi zawierać cyfrę',
  },
  {
    label: 'Min. 1 znak specjalny',
    test: (candidate) => /[^\w\s]/.test(candidate),
    errorMessage: () => 'Hasło musi zawierać znak specjalny, np. ! @ # $',
  },
  {
    label: 'Brak spacji',
    test: (candidate) => /^\S*$/.test(candidate),
    errorMessage: () => 'Hasło nie może zawierać spacji',
  },
];

const usePasswordValidation = (value: string) => useMemo(
  () => {
    const failedRule = rules.find(rule => !rule.test(value));
    return {
      isValid: !failedRule,
      errorMessage: failedRule?.errorMessage(value) ?? null,
      rules: rules.map(rule => ({
        label: rule.label,
        isOk: rule.test(value),
      })),
    };
  },
  [value],
);

export default usePasswordValidation;
